<template>
  <div class="contents">
    <div class="wrap">
      <section>
        <h2 v-if="regData.status != 'M'" class="page_title --view">약재입고 신규 등록</h2>
        <h2 v-if="regData.status == 'M'" class="page_title --view">약재입고 수정</h2>
      </section>
      <section class="view">
        <div class="table_list">
          <table class="write">
            <colgroup>
              <col width="200">
              <col width="*">
            </colgroup>
            <tbody>
            <tr>
              <th><span class="emp">약재명</span></th>
              <td>
                <div class="form_inline">
                  <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.medHrbNm"
                         :readonly="this.regData.status == 'M'" @keyup.enter="fn_click_medicineSearch">
                  <button v-if="this.regData.status != 'M'" class="btn btn_md btn_deepblue"
                          @click="fn_click_medicineSearch">검색
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th><span class="emp">원산지</span></th>
              <td>
                <div class="form_inline">
                  <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.orgPlceNm">
                  <button class="btn btn_md btn_deepblue" v-b-modal.orgPlaceSearch>검색</button>
                </div>
              </td>
            </tr>
            <tr>
              <th><span class="emp">규격여부</span></th>
              <td>
                <div class="form_inline">
                  <div class="form_radio" v-for="(item, index) in standardTypeList" :key="index">
                    <input type="radio" :id="index" name="standardTyperadio" :value="item.dtl_code"
                           v-model="regData.standardType" @change="fn_change_standardType">
                    <label :for="index">{{ item.dtl_code_nm }}</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th><span class="emp">약재 입고일자</span></th>
              <td>
                <Datepicker v-model="regData.wrhsDt" :defaultDate="regData.wrhsDt" :format="'YYYY-MM-DD'"/>
              </td>
            </tr>
            <tr>
              <th><span :class="regData.standardYn == 'Y' ? 'emp' : '' ">제약회사</span></th>
              <td>
                <div class="form_select" v-if="regData.standardType == 'S'">
                  <b-form-select v-model="regData.companyCd" @change="fn_set_product_code" :disabled="disableYn">
                    <b-form-select-option value=""><span>선택</span></b-form-select-option>
                    <b-form-select-option v-for="(item, index) in pharmaceuticalCompanyList" :key="index"
                                          :value="item.companyCd">{{ item.companyNm }}
                    </b-form-select-option>
                  </b-form-select>
                </div>
                <div class="form_inline" v-if="regData.standardType == 'E'">
                  <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.companyNm">
                  <button class="btn btn_md btn_deepblue" v-b-modal.companyListSearch>검색</button>
                </div>
                <div class="form_inline" v-if="regData.standardType == 'N'">
                  {{ regData.companyNm }}
                </div>
              </td>
            </tr>
            <tr>
              <th><span :class="regData.standardType == 'S' ? 'emp' : '' ">제품코드</span></th>
              <td v-if="regData.standardType == 'S'">
                <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.productCd"
                       readonly>
              </td>
              <td v-else>해당 규격유형은 제품코드가 필요하지 않습니다.</td>
            </tr>
            <tr>
              <th><span class="emp">약재 입고량(g)</span></th>
              <td><input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.wrhsQnty"
                         @change="fn_calculate_price"
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"><span>g</span>
              </td>
            </tr>
            <tr>
              <th><span class="emp">약재 입고단가</span></th>
              <td><input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.wrhsPrice"
                         @change="fn_calculate_price"
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"><span>원</span>
              </td>
            </tr>
            <tr v-if="this.regData.standardYn == 'Y'">
              <th><span class="emp">건보단가(g당)</span></th>
              <td><input type="text" class="form_control limit" placeholder="자동계산" v-model="regData.gunboPrice"
                         readonly="readonly"><span>원</span></td>
            </tr>
            <tr>
              <th><span class="emp">일반단가(g당)</span></th>
              <td><input type="text" class="form_control limit" placeholder="자동계산" v-model="regData.standPrice"
                         readonly="readonly"><span>원</span></td>
            </tr>
            <tr>
              <th>유통기한</th>
              <td>
                <Datepicker v-model="regData.exprDt" :defaultDate="regData.exprDt" :format="'YYYY-MM-DD'"/>
              </td>
            </tr>
            <tr v-if="regData.status == 'M'">
              <th>사용량</th>
              <td>{{ regData.useQnty }}</td>
            </tr>
            <tr v-if="regData.status == 'M'">
              <th>사용완료여부</th>
              <td>{{ regData.useCmptYn }}</td>
            </tr>
            <tr v-if="regData.status == 'M'">
              <th>폐기처리여부</th>
              <td>{{ regData.useDpslYn }}</td>
            </tr>
            <tr v-if="regData.status == 'M'">
              <th>폐기수량</th>
              <td>{{ regData.useDpslQnty }} g</td>
            </tr>
            <tr>
              <th>비고</th>
              <td><textarea name="" id="" class="form_control" placeholder="입력해주세요." v-model="regData.rmk"></textarea>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="bottom_box">
            <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
            <div class="btn_box">
              <!-- <button class="btn btn_md btn_gray">취소</button> -->
              <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
            </div>
          </div>
        </div>
      </section>
    </div>
    <adminMedicineSearch
        :title="'관리자 약재 검색'"
        :searchName="'약재명'"
        :searchData="regData.medHrbNm"
        :oneBtn="true"
        :btnLeft="'적용'"
        :btnRight="'닫기'"
        @callback="fn_callback"
    />
    <SearchOrgPlaceModal
        :title="'원산지 검색'"
        :searchName="'원산지'"
        :searchData="regData.orgPlcNm"
        :oneBtn="true"
        :btnLeft="'적용'"
        :btnRight="'닫기'"
        @callback="fn_orgPlace_callback"
    />
    <SearchCompanyModal
        :title="'제약회사 검색'"
        :searchName="'제약회사'"
        :searchData="regData.companyNm"
        :oneBtn="true"
        :btnLeft="'적용'"
        :btnRight="'닫기'"
        @callback="fn_company_callback"
    />
  </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import Datepicker from '@/components/Datepicker.vue'
import adminMedicineSearch from "@/modal/admin/adminMedicineSearch.vue"
import SearchOrgPlaceModal from "@/modal/common/orgPlaceSearch.vue"
import SearchCompanyModal from "@/modal/admin/companyListSearch.vue"

export default {
  name: 'MedicineWrhsMngtReg',
  components: {
    Datepicker,
    adminMedicineSearch,
    SearchOrgPlaceModal,
    SearchCompanyModal
  },
  mixins: [commonUtil],
  data() {
    return {
      selected: null,
      pharmaceuticalCompanyList: [],
      standardTypeList: [],
      disableYn: false,
      regData: {
        medWrhsCd: "",
        medHrbCd: "",
        medHrbNm: "",
        standardYn: "Y",
        standardType: "S",
        orgPlceCd: "",
        orgPlceNm: "",
        companyCd: "",
        companyNm: "",
        productCd: "",
        wrhsDt: "",
        wrhsQnty: "",
        wrhsPrice: "",
        gunboPrice: "",
        standPrice: "",
        exprDt: "",
        useQnty: "",
        useCmptYn: "",
        useDpslYn: "",
        useDpslQnty: "",
        rmk: "",
        status: ''
      },
    }
  },
  async created() {
    //공통코드 - 규격유형
    this.standardTypeList = await this.getCode('GC00000017');
  },
  mounted() {
    this.regData.status = this.$store.getters['medWrhs/getStatus'];


    if (this.regData.status == 'M') {

      this.fn_search()

    }
  },
  methods: {
    fn_click_medicineSearch() {
      //약재 정보 모달 show
      this.$bvModal.show("medicineSearch");
    },
    fn_callback(medObject) {
      //약재 정보 콜백정보
      this.regData.medHrbCd = medObject.med_hrb_cd;
      this.regData.medHrbNm = medObject.med_hrb_nm;

      //제품코드 조회
      this.fn_search_product_code(this.regData);

    },
    fn_orgPlace_callback(orgPlceObj) {

      console.log("### orgPlceObj : %o", orgPlceObj);

      //원산지 정보 콜백정보
      this.regData.orgPlceCd = orgPlceObj.org_plce_cd;
      this.regData.orgPlceNm = orgPlceObj.org_plce_nm;

      console.log("### this.regData.orgPlceCd : %o", this.regData.orgPlceCd);
    },
    fn_search_product_code(medObject) {

      //제품코드 조회
      let param = new Object();
      param.medHrbCd = medObject.medHrbCd;

      axios
          .post("/api/medicine/getCompanySelectList", param)
          .then((res) => {
            console.log("@@@@ getCompanySelectList data : %o", res.data);
            this.pharmaceuticalCompanyList = res.data.companyList;
            // this.regData.companyCd = "";
            // this.regData.productCd = "";

            if (this.pharmaceuticalCompanyList.length == 0) {
              alert("제품코드가 없습니다. 제품코드를 입력해주세요");
            }
          })
          .catch((err) => console.log(err));
    },
    fn_set_product_code() {
      let productCd = "";
      //제품코드 가져오기
      this.pharmaceuticalCompanyList.find((el) => {
        if (el.companyCd == this.regData.companyCd) {
          productCd = el.product_code;
          return;
        }
      });

      this.regData.productCd = productCd;

    },
    // fn_company_callback(companyObject){
    //   this.regData.companyCd = companyObject.companyCd;
    // 	this.regData.companyNm = companyObject.companyNm;
    // },
    fn_move_page() {
      this.$store.dispatch('medWrhs/setStatus', '');
      this.$router.push("/admin/medicine/MedicineWrhsMngt");
    },
    fn_reg() {

      if (this.regData.medHrbCd == '') {
        alert("약재를 선택해주세요");
        return;
      }

      if (this.regData.wrhsDt == '') {
        alert("입고일자를 선택해주세요");
        return;
      }

      if (this.regData.wrhsQnty == '') {
        alert("약재입고량을 입력해주세요");
        return;
      }

      if (this.regData.orgPlceCd == '' || this.regData.orgPlceNm == '') {
        alert("원산지를 입력해주세요");
        return;
      }

      if (this.regData.wrhsPrice == '') {
        alert("입고입고가격을 입력해주세요");
        return;
      }

      if (this.regData.companyCd == '') {
        alert("제약회사를 선택해주세요");
        return;
      }

      if (this.regData.standardType == 'S' && this.regData.productCd == '') {
        alert("제품코드가 없습니다");
        return;
      }


      axios
          .post("/api/medicineWrhs/regMedicineWrhs", this.regData)
          .then((res) => {
            console.log("@@@@ res : %o", res);

            alert("저장되었습니다");
            this.fn_move_page();
          })
          .catch((err) => console.log(err));


    },
    fn_search() {

      let param = new Object();
      param.medWrhsCd = this.$store.getters['medWrhs/getMedWhrsCd'];

      console.log("@@@@ param : %o", param);

      axios
          .post("/api/medicineWrhs/medicineWrhsDetail", param)
          .then((res) => {
            console.log("@@@@ dtl res data : %o", res.data.medWrhsInfo);

            this.regData.medWrhsCd = res.data.medWrhsInfo.med_wrhs_cd;
            this.regData.medHrbCd = res.data.medWrhsInfo.med_hrb_cd;
            this.regData.medHrbNm = res.data.medWrhsInfo.med_hrb_nm;
            this.regData.orgPlceCd = res.data.medWrhsInfo.org_plce_cd;
            this.regData.orgPlceNm = res.data.medWrhsInfo.org_plce_nm;
            this.regData.companyCd = res.data.medWrhsInfo.companyCd;
            this.regData.companyNm = res.data.medWrhsInfo.companyNm;
            this.regData.productCd = res.data.medWrhsInfo.product_cd;
            this.regData.wrhsDt = res.data.medWrhsInfo.wrhs_dt;
            this.regData.wrhsQnty = res.data.medWrhsInfo.wrhs_qnty;
            this.regData.wrhsPrice = res.data.medWrhsInfo.wrhs_price;
            this.regData.gunboPrice = res.data.medWrhsInfo.gunbo_price;
            this.regData.standPrice = res.data.medWrhsInfo.stand_price;
            this.regData.exprDt = res.data.medWrhsInfo.expr_dt;

            this.regData.useQnty = res.data.medWrhsInfo.use_qnty;
            this.regData.useCmptYn = res.data.medWrhsInfo.use_cmpt_yn;
            this.regData.useDpslYn = res.data.medWrhsInfo.use_dpsl_yn;
            this.regData.useDpslQnty = res.data.medWrhsInfo.use_dpsl_qnty;
            this.regData.rmk = res.data.medWrhsInfo.rmk;

            this.regData.medHrbDtlSeq = res.data.medWrhsInfo.med_hrb_dtl_seq;

            this.regData.standardType = res.data.medWrhsInfo.standard_type;

            if(this.regData.standardType == 'S'){
              this.disableYn = false;
              //제품코드 조회 (companyCd는 이미 설정됨, 목록 조회 후 자동 선택)
              this.fn_search_product_code(this.regData);
            } else {
              this.disableYn = true;
            }


            console.log("@@@@ dtl this.regData : %o", this.regData);

          })
          .catch((err) => console.log(err));

    },
    fn_calculate_price() {

      if (this.regData.wrhsPrice != "" && this.regData.wrhsPrice > 0) {
        let gunboPrice = this.regData.wrhsPrice / this.regData.wrhsQnty;

        // 현재 1.3 - 1.2%변경
        let stabdPrice = gunboPrice * 1.3;

        this.regData.gunboPrice = gunboPrice;
        this.regData.standPrice = stabdPrice;
      }
    },
    fn_company_callback(companyObject) {
      this.regData.companyCd = companyObject.companyCd;
      this.regData.companyNm = companyObject.companyNm;
    },
    fn_change_standardType() {
      if (this.regData.standardType === "S") {
        this.regData.companyCd = "";
        this.regData.companyNm = "";
        this.regData.productCd = "";
      } else if (this.regData.standardType === "E") {
        this.regData.companyCd = "";
        this.regData.companyNm = "";
        this.regData.productCd = "";
      } else {
        // N: 기타로 고정
        this.regData.companyCd = "PMCP999999";
        this.regData.companyNm = "기타";
        this.regData.productCd = "";
      }
    }
  }
}
</script>